import React from "react";
import { Button } from "../ui/button";
import { useRef, useState, useEffect, useContext } from "react";
import { toast } from "../ui/use-toast";
import JdApi from "../../apis/CreateJd/index";
import useStore from "../../store/useStore";
import { useNavigate } from "react-router-dom";
import { Loader, Loader2 } from "lucide-react";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
const CreateRole = () => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [filename, setFileName] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const token = useStore((state) => state.token);
  const fileId = useRef(null);
  const [name, setName] = useState(""); 
  const navigate = useNavigate();
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (selectedFile) {
      const validTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];
      if (validTypes.includes(selectedFile.type)) {
        setFile(selectedFile);
        handleUpload(selectedFile);
      } else {
        console.log("File is not uploaded called here");
        toast({
          variant: "destructive",
          title: "File is not uploaded ",
          description: "Only .doc, .docx, or .pdf files are allowed.",
        });

        setFile(null);
      }
    }
  };
  const handleUpload = async (selectedFile) => {
    const file = selectedFile;

    setUploading(true);
    try {
      if (!file) {
        toast({
          title: "Select the file ",
          description: "Please Select the file",
        });
        // toast.success("Please select a file")
        return;
      }
     
      const formData = new FormData();
      formData.append("file", selectedFile); // ✅ Ensure key matches API expectation
      const data = await JdApi.createfileId({ file: formData, token: token });
      fileId.current = data.data.fileId;
      if(data.data.fileId){
        setUploaded(true);
      }
      setFileName(file.name);
     
    } catch (error) {
      toast({
        variant: "destructive",
        title: "File is not uploaded ",
        description: "Only .doc, .docx, or .pdf files are allowed.",
      });
    } finally {
      setUploading(false);
    }
  };

  const handleIconClick = async () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // handle submit
  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!fileId.current && !description) {
        toast({
          variant: "destructive",
          title: "Please fill the required field ",
          description: "Please upload the file or add description",
        });
        return;
      }
   
      if (!name) {
        toast({
          variant: "destructive",
          title: "Please fill the required field ",
          description: "Please enter the name of the exam",
        });
      
        return;
      }
      const data = await JdApi.createJdId({
        fileId: fileId.current,
        token: token,
        name: name,
        description: description,
      });
      if (data?.status) {
        toast({
          variant: "success",
          title: "Jd Created Successfully",
          description: "Jd Created Successfully",
        });
        navigate("/assessments");
      }
      
    } catch (error) {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Error in creating Jd",
      })
    }
    finally{
      setLoading(false);
    }
   
  };

  return (
    <div className="w-full max-w-[1800px] mx-auto px-6 py-2 mt-2 h-[80vh]">
      {/* Header Section */}
      <div className="flex  flex-col justify-center  items-center gap-6">
        <div className="text-3xl font-semibold  text-center max-sm:text-xl font-source-sans-pro ">
          Let's Create the role that you are looking to hire for
        </div>
        <div className="flex flex-col gap-3 justify-center  w-full max-w-2xl ">
        <Label>Name of the Exam</Label>
      <Input
        type="text"
        placeholder="Enter the name of the exam"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
        </div>

        <div
          className="mx-auto max-w-2xl w-full rounded-lg p-4 text-center"
          style={{ border: "0.5px dashed #000000" }}
        >
          <input
            type="file"
            id="fileInput"
            onChange={handleFileChange}
            className="hidden"
            ref={fileInputRef}
          />
          <div className="file-drop-area flex h-36 flex-col items-center justify-center">
            <p className="text-[#383838] text-sm font-source-sans-pro">
              Drag and drop your job description file here
            </p>
            {filename && (
              <p className="text-[#4D80F4] text-sm font-source-sans-pro mt-1">
                {filename}
              </p>
            )}
            <button
              type="button"
              className={`mt-4 rounded-full border border-[#4D80F4] px-4 py-2 text-blue-500 hover:bg-gray-100 flex items-center gap-2  `}
              onClick={handleIconClick}
            >
              {uploaded ? (
                <div>Edit JD file</div>
              ) : uploading ?(<div className="flex items-center gap-2"> <Loader2 className="animate-spin" />
          Uploading Jd </div>):(
                <div className=" flex items-center gap-1">
                  <div>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.5 3.75V14.25"
                        stroke="#4D80F4"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.25 9H14.75"
                        stroke="#4D80F4"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="mb-0.5">Browse Files</div>
                </div>
              )}
            </button>
          </div>
        </div>

        <textarea
          placeholder="Paste or type Jd description here ."
          className="w-full  max-w-2xl h-40 border-2 px-2 py-4 rounded-md bg-gray-100 overflow-y-auto hover:border-[#4D80F4] outline-none"
          value={description} // Bind the state to the textarea
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>

        <div>
          <Button onClick={handleSubmit} className="flex items-center gap-2">
           {loading&&  <Loader2 className="animate-spin" />}
            Submit Jd
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CreateRole;
